import { render, staticRenderFns } from "./user_data.vue?vue&type=template&id=47d60cc6"
import script from "./user_data.vue?vue&type=script&lang=js"
export * from "./user_data.vue?vue&type=script&lang=js"
import style0 from "./user_data.vue?vue&type=style&index=0&id=47d60cc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports